import { Doughnut, Pie , Bar} from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend ,
  CategoryScale,
  LinearScale,
  BarElement,
  Title} from 'chart.js';
import "./stackBarChart.scss";


ChartJS.register(  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,ArcElement);

 /* 
const labels = ['Geetha', 'Shivani', 'Anusha', 'Amruta', 'Aniket', 'Arpitha', 'Vinay'];
export const stackBarChartResumes = {
  labels,
  datasets: [
    {
      label: 'Total Uploaded',
      data: labels.map(() => 20),
      backgroundColor: 'rgb(255, 99, 132)',
    },
    {
      label: 'Available',
      data: labels.map(() => 30),
      backgroundColor: 'rgb(75, 192, 192)',
    },
    {
      label: 'Shared',
      data: labels.map(() => 40),
      backgroundColor: 'rgb(53, 162, 235)',
    },
    {
      label: 'NP/B/JD/CB',
      data: labels.map(() => 40),
      backgroundColor: 'rgb(53, 162, 235)',
    },
  ],
};    
*/
 
function StackBarChart({ stackBarData, stack, showTitle, MAX }) {
  const datasets = stackBarData?.datasets ?? [];
  const labels = stackBarData?.labels ?? [];

  

  const toNumber = (v) => (typeof v === "number" && isFinite(v) ? v : 0);

  let maxValue = 0;

  if (stack) {
    const len =
      labels.length ||
      Math.max(0, ...datasets?.map((ds) => (ds?.data?.length ?? 0)));
    for (let i = 0; i < len; i++) {
      let sum = 0;
      for (const ds of datasets) {
        sum += toNumber(ds?.data?.[i]);
      }
      if (sum > maxValue) maxValue = sum;
    }
  } else {
    for (const ds of datasets) {
      for (const v of ds?.data ?? []) {
        const num = toNumber(v);
        if (num > maxValue) maxValue = num;
      }
    }
  }

  const dynamicMax = Math.max(10, Math.ceil(maxValue / 10) * 10);

  return (
    <div >
        <Bar
          data={stackBarData}
          options={{
            plugins: {
              title: {
                display: true,
                text: showTitle
              },
            },
            responsive: true,
            scales:{
              x: {
                stacked: stack,                            
              },
              y: {
                stacked: stack, 
                min:0,
              max: dynamicMax,
              }
            }
          }}
        />
      </div>
  );
}
export default StackBarChart;